/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type PdpRespSidebarSellerInfo_viewer$ref = any;
export type PdpRespSidebarSellerInfo_viewer = {
    readonly isReviewsEnabled: boolean | null;
    readonly isNewSellerPillEnabled: boolean | null;
    readonly " $refType": PdpRespSidebarSellerInfo_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpRespSidebarSellerInfo_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": "isReviewsEnabled",
            "name": "isEnabledByLocale",
            "args": [
                {
                    "kind": "Literal",
                    "name": "featureName",
                    "value": "ORDER_FEEDBACK"
                }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"ORDER_FEEDBACK\")"
        },
        {
            "kind": "ScalarField",
            "alias": "isNewSellerPillEnabled",
            "name": "isEnabled",
            "args": [
                {
                    "kind": "Literal",
                    "name": "key",
                    "value": "enableNewSellerPill"
                }
            ],
            "storageKey": "isEnabled(key:\"enableNewSellerPill\")"
        }
    ]
} as any);
(node as any).hash = '342b18fbb45362c28bfceff8ffc97a84';
export default node;
